import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useCategories } from "./useCategories";

export function usePersonalInfoSubmit(profile: any, onUpdate?: () => void) {
  const { loadingCategories } = useCategories(profile);

  const onSubmit = async (values: any) => {
    try {
      const { error } = await supabase
        .from("profiles")
        .update({
          full_name: values.full_name,
          headline: values.headline,
          bio: values.bio,
          category_id: values.category_id,
        })
        .eq("id", profile.id);

      if (error) throw error;

      toast.success("Profile updated successfully");
      if (onUpdate) onUpdate();
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Failed to update profile");
    }
  };

  return { onSubmit, loadingCategories };
}